import { useRef, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Тултип через портал с fixed-позиционированием — его НЕ обрезает overflow
 * родителей (в отличие от CSS ::after). Авто-флип у краёв окна.
 */
export function Tooltip({
  label,
  children,
  placement = 'bottom',
}: {
  label: string;
  children: ReactNode;
  placement?: 'top' | 'bottom';
}) {
  const wrapRef = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState<{ x: number; y: number; place: 'top' | 'bottom' } | null>(null);

  const show = () => {
    const el = wrapRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    let place = placement;
    if (place === 'top' && r.top < 48) place = 'bottom';
    if (place === 'bottom' && r.bottom > window.innerHeight - 48) place = 'top';
    setPos({
      x: r.left + r.width / 2,
      y: place === 'bottom' ? r.bottom + 8 : r.top - 8,
      place,
    });
  };
  const hide = () => setPos(null);

  return (
    <span
      ref={wrapRef}
      style={{ display: 'inline-flex' }}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocusCapture={show}
      onBlurCapture={hide}
    >
      {children}
      {pos &&
        createPortal(
          <div
            className="tooltip-pop"
            data-place={pos.place}
            style={{ position: 'fixed', left: pos.x, top: pos.y }}
            role="tooltip"
          >
            {label}
          </div>,
          document.body,
        )}
    </span>
  );
}
